import * as yup from 'yup'
import { linkValidation } from 'components/Project/IsaacTable'

export const validator = yup.object().shape({ isaacLinks: linkValidation })
